.overlay {
  width: 100%;
  height: 100%;
  &:after {
    display: block;
    position: absolute;
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
    height: 100%;
    width: 100%;
    content: '';
    top: 0;
  }
}
